<div class="zone-wrapper">
  <ejs-tab #tabGroup
           id="element"
           class="mt-2"
           [animation]="tabAnimation"
           heightAdjustMode="fill"
           (selecting)="tabSelect($event)">
    <e-tabitems>
      <e-tabitem>
        <ng-template #headerText>
          {{'i18n.domain.administration.zone-details.tab.general' | translate}}
          <span class="icon-warning--alt text-warning ms-2" *ngIf="zoneForm.invalid"></span>
        </ng-template>
        <ng-template #content>
          <form class="form-horizontal" [formGroup]="zoneForm" *ngIf="isFormReady">
            <div class="p-2" [ngClass]='{"no-bottom-padding": isGroupingElement}'>
              <div class="form-row row">
                <div class="col-12 col-lg-6">
                  <div class="form-group row">
                    <label for="name" class="col-5 control-label required">
                      {{'i18n.domain.administration.zone-details.zone-details-form.fields.name' | translate}}
                    </label>
                    <div class="col-7">
                      <input type="text"
                             class="form-control e-textbox"
                             id="name"
                             formControlName="name">
                      <app-error-messages [control]="zoneForm.controls.name"
                                          [showUntouchedErrors]="showUntouchedErrors">
                      </app-error-messages>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="form-group row">
                    <label for="name" class="col-5 control-label">
                      {{'i18n.domain.administration.zone-details.zone-details-form.fields.groupingElement' | translate}}
                    </label>
                    <div class="col-7">
                      <app-yes-no-group-button id="groupingElement"
                                               formControlName="groupingElement"
                                               (click)="onGroupingElementClick()">
                      </app-yes-no-group-button>
                    </div>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="!isGroupingElement">
                <div class="form-row row">
                  <div class="col-12 col-lg-6">
                    <div class="form-group row">
                      <label class="col-5 control-label">
                        {{'i18n.domain.administration.zone-details.zone-details-form.fields.separateNfcCode' | translate}}
                      </label>
                      <div class="col-7">
                        <app-yes-no-group-button id="separateNFCCode" formControlName="separateNFCCode"></app-yes-no-group-button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6">
                    <div class="form-group row">
                      <label for="maxPassageTime" class="col-5 control-label required">
                        {{'i18n.domain.administration.zone-details.zone-details-form.fields.maxPassageTime' | translate}}
                      </label>
                      <div class="col-7 position-relative">
                        <input type="number"
                               class="form-control e-textbox input-field-with-unit--wide"
                               id="maxPassageTime"
                               formControlName="maxPassageTime">
                        <span class="multichar-unit">min</span>
                        <app-error-messages [control]="zoneForm.controls.maxPassageTime"
                                            [showUntouchedErrors]="showUntouchedErrors">
                        </app-error-messages>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row row">
                  <div class="col-12 col-lg-6">
                    <div class="form-group row">
                      <label class="col-5 control-label">
                        {{'i18n.domain.administration.zone-details.zone-details-form.fields.enableGpsDetection' | translate}}
                      </label>
                      <div class="col-7">
                        <app-yes-no-group-button id="enableGPSDetection" formControlName="enableGPSDetection"></app-yes-no-group-button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6">
                    <div class="form-group row">
                      <label for="nFCCode" class="col-5 control-label" [ngClass]="{'required': zoneForm.value.separateNFCCode}">
                        {{'i18n.domain.administration.zone-details.zone-details-form.fields.nfcCode' | translate}}
                      </label>
                      <div class="col-7">
                        <input type="text"
                               class="form-control e-textbox"
                               id="nFCCode"
                               formControlName="nFCCode">
                        <app-error-messages [control]="zoneForm.controls.nFCCode"
                                            [showUntouchedErrors]="showUntouchedErrors">
                        </app-error-messages>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row row">
                  <div class="col-12 col-lg-6">
                    <div class="form-group row">
                      <label class="col-5 control-label">
                        {{'i18n.domain.administration.zone-details.zone-details-form.fields.foreignParkersAllowed' | translate}}
                      </label>
                      <div class="col-7">
                        <app-yes-no-group-button id="foreignParkersAllowed" formControlName="foreignParkersAllowed"></app-yes-no-group-button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6">
                    <div class="form-group row">
                      <label class="col-5 control-label" [ngClass]="{'required': zoneForm.value.foreignParkersAllowed}">
                        {{'i18n.domain.administration.zone-details.zone-details-form.fields.foreignParkingSubscription' | translate}}
                      </label>
                      <div class="col-7">
                        <ejs-dropdownlist id="foreignParkingSubscriptionId"
                                          formControlName="foreignParkingSubscriptionId"
                                          [dataSource]="parkingSubscriptionsDropdownValues"
                                          [fields]="dropdownSettings"
                                          [showClearButton]="true"
                                          (select)="onSelectForeignParkingSubscription($event)">
                          <ng-template #itemTemplate let-data>
                            <div [ngClass]="{'disabled': data?.disabled}">{{data?.name}}</div>
                          </ng-template>
                        </ejs-dropdownlist>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row row">
                  <div class="col-12 col-lg-6">
                    <div class="form-group row">
                      <label for="parkingSpaceCapacity" class="col-5 control-label">
                        {{'i18n.domain.administration.zone-details.zone-details-form.fields.parkingSpaceCapacity' | translate}}
                      </label>
                      <div class="col-7">
                        <input type="number"
                               class="form-control e-textbox"
                               id="parkingSpaceCapacity"
                               formControlName="parkingSpaceCapacity">
                        <app-error-messages [control]="zoneForm.controls.parkingSpaceCapacity"
                                            [showUntouchedErrors]="showUntouchedErrors">
                        </app-error-messages>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6">
                    <div class="form-group row">
                      <div class="col-5 d-flex gap-1 align-items-center">
                        <label for="parkingSpaceNumberDefinition" class="control-label">
                          {{'i18n.domain.administration.zone-details.zone-details-form.fields.parkingSpaceNumberDefinition' | translate}}
                        </label>
                        <ejs-tooltip id='tooltip' content="{{ 'i18n.shared.parking-space-number-information' | translate }}">
                          <span class="icon-information"></span>
                        </ejs-tooltip>
                      </div>
                      <div class="col-7">
                        <input type="text"
                               class="form-control e-textbox"
                               id="parkingSpaceNumberDefinition"
                               formControlName="parkingSpaceNumberDefinition">
                        <app-error-messages [control]="zoneForm.controls.parkingSpaceNumberDefinition"
                                            [showUntouchedErrors]="showUntouchedErrors">
                        </app-error-messages>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-lg-6">
                    <div class="form-group row">
                      <label for="currentParkerCount" class="col-5 control-label">
                        {{'i18n.domain.administration.zone-details.zone-details-form.fields.currentParkerCount' | translate}}
                      </label>
                      <div class="col-7">
                        <div class="input-group">
                          <input type="number"
                                 class="form-control e-textbox"
                                 id="currentParkerCount"
                                 formControlName="currentParkerCount">
                          <button *ngIf="isUpdateMode"
                                  class="btn btn-icon e-icons icon-save"
                                  [ngClass]="{'btn-primary': hasCurrentParkerCountChanged, 'btn-secondary': !hasCurrentParkerCountChanged}"
                                  [disabled]="!hasCurrentParkerCountChanged"
                                  (click)="updateParkingSpaceCounter()">
                          </button>
                        </div>
                        <app-error-messages [control]="zoneForm.controls.currentParkerCount"
                                            [showUntouchedErrors]="showUntouchedErrors">
                        </app-error-messages>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row spacer" *ngIf="isMapEnabled">
                  <div class="col-12 col-lg-6">
                    <app-map-box-map [(mapData)]="mapData" mapId="zoneMap" [isSingleMode]="false"></app-map-box-map>
                    <input type="hidden"
                           id="zoneGpsArea"
                           formControlName="zoneGPSArea">
                  </div>
                </div>
              </ng-container>
            </div>
          </form>
        </ng-template>
      </e-tabitem>

      <e-tabitem>
        <ng-template #headerText>
          {{'i18n.domain.administration.zone-details.tab.blacklist' | translate}}
        </ng-template>
        <ng-template #content>
          <app-zone-details-blacklist [useBlacklistArea]="zoneForm.controls.useBlacklistArea.value"
                                      [blacklistArea]="zoneForm.controls.blacklistGPSArea.value"
                                      (dataChange)="onBlacklistDataChange($event)">
          </app-zone-details-blacklist>
        </ng-template>
      </e-tabitem>
    </e-tabitems>
  </ejs-tab>
</div>
<div class="detail-footer p-2 pt-3">
  <button type="button"
          class="btn btn-danger me-auto"
          *ngIf="!!zoneForm.controls.id"
          [disabled]="!canDelete || isBusy"
          (click)="onDeleteZone()">
    {{'i18n.domain.administration.zone-details.messages.delete-title' | translate}}
  </button>
  <button type="button"
          class="btn btn-secondary me-2"
          [disabled]="isBusy"
          (click)="onCancelClicked()">
    {{cancelButtonText | translate}}
  </button>
  <button type="button"
          class="btn btn-primary"
          [disabled]="!zoneForm.valid || (!formChanged && !hasGpsAreaChanged) || isBusy"
          (click)="submitForm()">
    {{'i18n.shared.save' | translate}}
  </button>
</div>
